import React, {useState,useRef} from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import {FormGroup, Label,Col,Input,Row,Button} from "reactstrap";
import MyAlert from '../MyAlert';
import {GetMessage} from "../../Modules/Message";
import {GetToken,GetTitServizi} from "../../Modules/Funzioni";
import "../../Modules/Costanti";
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import SimpleReactValidator from 'simple-react-validator';
import '../../css/Form.css';
export default function ModServizio(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const MsgAlertDefault="Per confermare la modifica controllare i campi obbligatori e correggere eventuali errori!";
    const [isSubmit, setisSubmit] = React.useState(false);
    //alert object
    const [OpenAlert, setOpenAlert] = React.useState(false);
    const [MsgAlert,setMsgAlert]=React.useState(MsgAlertDefault);
    const onCloseAlert = (event) => {
        setOpenAlert(false);
    };
    //------------
    const [SeverityAlert, setSeverityAlert] = React.useState("error");
    const [isLoading, setIsLoading] = useState(false);
    const [Descrizione, setDescrizione] = React.useState("");
    const [Rischio, setRischio] = React.useState("");
    const [Titolo, setTitolo] = React.useState("");
    const [MesiValidita, setMesiValidita] = React.useState("");
    const [Ore, setOre] = React.useState("");
    const [Nominale, setNominale] = React.useState(0);
    const [TipoNomina, setTipoNomina] = React.useState(0);
    const [PermettiDownload, setPermettiDownload] = React.useState(0);
    const handleDescrizione = (event) => {  
        setDescrizione(event.target.value);  
    }; 
    const handleRischio = (event) => {  
        setRischio(event.target.value);  
    }; 
    const handleTitolo = (event) => {  
        setTitolo(event.target.value);  
    }; 
    const handleMesiValidita = (event) => {  
        setMesiValidita(event.target.value);  
    }; 
    const handleOre = (event) => {  
        setOre(event.target.value);  
    }; 
    const handleNominale = (event) => {  
        setNominale(event.target.value);  
    }; 
    const handleTipoNomina = (event) => {  
        setTipoNomina(event.target.value);  
    }; 
    const handlePermettiDownload = (event) => {  
        setPermettiDownload(event.target.value);  
    };
  React.useEffect(() => {
    if (props.id!==""){
        LoadData();
    }
}, [props.id]);

const validator = useRef(new SimpleReactValidator({
    messages: {
        default: 'obbligatorio o non corretto!'
      },
      validators: {
        cphone: {  // name the rule
          //message: 'obbligatorio o non corretto',
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val,/^[0-9]{2,5}-[0-9]{5,10}$/i) && params.indexOf(val) === -1
          },
          //messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          //required: true  // optional
        }
      }
}));  

const LoadData = (event) => {
    if(props.id!==""){
        setIsLoading(true); 
        const token = GetToken(localStorage.getItem("token"));
        const ax= axios;
        ax.defaults.headers.common['Authorization']="Bearer " + token;
        (async () => {
            let result=[];
            try{
                let url=process.env.REACT_APP_API_URL+'servizio/' + props.id;               
                result = await ax.post(url);
                setDescrizione(result.data[0].Descrizione);
                setRischio(result.data[0].Rischio);
                setTitolo(result.data[0].Titolo);
                setOre(result.data[0].Ore);
                setMesiValidita(result.data[0].MesiValidita);
                setNominale(String(result.data[0].Nominale));
                setTipoNomina(result.data[0].TipoNomina);
                setPermettiDownload(result.data[0].PermettiDownload);
            }
            catch(error) {
                let msg=""
                if (error.response!==undefined) {
                    msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                }
                else
                {
                    msg=GetMessage(undefined,"");
                }
                setSeverityAlert("warning")
                setMsgAlert(msg);
                setOpenAlert(true);

            }
            setIsLoading(false);    
        })();  
    }  
}

const submitForm= (event) => 
{
    if (validator.current.allValid()) {
        setisSubmit(true);
        const fd = new FormData();
        fd.append("id", props.id);
        fd.append("Descrizione", Descrizione);
        fd.append("Rischio", Rischio);
        fd.append("Titolo", Titolo);
        fd.append("MesiValidita", MesiValidita);
        fd.append("Ore", Ore);
        fd.append("Nominale", Nominale);
        fd.append("TipoNomina", TipoNomina);
        fd.append("PermettiDownload", PermettiDownload);

        const token = GetToken(localStorage.getItem("token"));
        const ax= axios;
        ax.defaults.headers.common['Authorization']="Bearer " + token;
        const axiosConfig = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
            
        ax
        
        .post(process.env.REACT_APP_API_URL+'servizioupdate', fd,axiosConfig)
        .then((response) => {
            
            
            if (response.status === 200) {
                if (response.data.error==="OK"){
                    props.handleClose();
                    props.onUpdate();
                }
                else {
                    let msg="";
                    let ris=JSON.stringify(response.data);
                    ris=ris.replaceAll("\"", "");
                    ris=ris.replaceAll("{", "");
                    ris=ris.replaceAll("}", "");
                    ris=ris.replaceAll("[", "");
                    ris=ris.replaceAll("]", "");
                    msg="errore durante la modifica! " + ris;
                    setSeverityAlert("error")
                    setMsgAlert(msg);
                    setOpenAlert(true);
                }
            }
            else
            { 
            const msg=GetMessage(response.status,response.data.message);
            setSeverityAlert("error")
            setMsgAlert(msg);
            setOpenAlert(true);
            }
        })
        .catch((error) => {
                let msg=""
                if (error.response!==undefined) {
                    msg=GetMessage(error.response.status,error.response.data.message || error.response.message);
                }
                else
                {
                    msg=GetMessage(undefined,"");
                }
                setSeverityAlert("error")
                setMsgAlert(msg);
                setOpenAlert(true);
            });
            setisSubmit(false);
    } else {
        validator.current.showMessages();
        setSeverityAlert("error")
        setMsgAlert(MsgAlertDefault);
        //setValueForceUpdate(ValueForceUpdate => ++ValueForceUpdate);
        setOpenAlert(true);
    }
}

  return (
      <Dialog
        fullScreen={fullScreen}
        open={true} 
        onClose={props.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Modifica Servizio</DialogTitle>
        <DialogContent className="form-popup">
          <DialogContentText>
          <MyAlert message={MsgAlert} severity={SeverityAlert} handleClose={onCloseAlert} vertical="top" horizontal="center" open={OpenAlert}/>     
          {isLoading ? ( <CircularProgress className="sp-center" /> ) : (<span></span>) }
            <Row>
                <Col md={12}>
                    <FormGroup>
                        <Label for="selTitolo">Titolo *</Label>
                        <Input type="select" name="selTitolo" 
                        id="selTitolo" placeholder="" value={Titolo} onChange={handleTitolo}
                        onBlur={() => validator.current.showMessageFor('Titolo')}
                        >
                                <option key="" value=""></option>
                                {GetTitServizi().map((item) => (
                                    <option key={item.titolo_value} value={item.titolo_value}>{item.titolo_name}</option>
                                ))}
                        </Input>
                        {validator.current.message('Titolo', Titolo, 'required|string', { className: 'text-danger' })}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <FormGroup>
                        <Label for="txtDescrizione">Descrizione *</Label>
                        <Input type="text" name="txtName" autoComplete="new-password" placeholder=""
                        onBlur={() => validator.current.showMessageFor('Descrizione')}
                        value={Descrizione} onChange={handleDescrizione}
                        />
                        {validator.current.message('Descrizione', Descrizione, 'required|string', { className: 'text-danger' })}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <Label for="selRischio">Rischio *</Label>
                        <Input type="select" name="selRischio" 
                        id="selRischio" placeholder="" value={Rischio} onChange={handleRischio}
                        onBlur={() => validator.current.showMessageFor('Rischio')}
                        >
                                <option key="" value=""></option>
                                <option key="0" value="0">Indifferente</option>
                                <option key="1" value="1">Alto</option>
                                <option key="2" value="2">Medio</option>
                                <option key="3" value="3">Basso</option>
                        </Input>
                        {validator.current.message('Rischio', Rischio, 'required|numeric', { className: 'text-danger' })}
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label for="txtOre">N. Ore *</Label>
                        <Input type="number" name="txtOre" autoComplete="new-password" placeholder=""
                        onBlur={() => validator.current.showMessageFor('Ore')}
                        value={Ore} onChange={handleOre}
                        />
                        {validator.current.message('Ore', Ore, 'required|numeric', { className: 'text-danger' })}
                    </FormGroup>
                </Col>
                <Col md={5}>
                    <FormGroup>
                        <Label for="txtValidita">Mesi Validità (Max 999) *</Label>
                        <Input type="number" name="txtValidita" autoComplete="new-password" placeholder=""
                        onBlur={() => validator.current.showMessageFor('MesiValidita')}
                        value={MesiValidita} onChange={handleMesiValidita}
                        />
                        {validator.current.message('MesiValidita', MesiValidita, 'required|numeric', { className: 'text-danger' })}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <Label for="selNominale">Nominale *</Label>
                        <Input type="select" name="selNominale" id="selNominale" placeholder=""
                            onBlur={() => validator.current.showMessageFor('Nominale')}
                            value={Nominale} onChange={handleNominale}
                            >
                                <option key=""></option>
                                <option key="0" value="0">No</option>
                                <option key="1" value="1">Si</option>
                            </Input>
                            {validator.current.message('Nominale', Nominale, 'required|numeric', { className: 'text-danger' })}
                    </FormGroup>
                </Col>
                { Nominale==="1" && (
                <Col md={8}>
                    <FormGroup>
                        <Label for="selTipoNomina">Tipo Nomina *</Label>
                        <Input type="select" name="selTipoNomina" id="selTipoNomina" placeholder=""
                            onBlur={() => validator.current.showMessageFor('TipoNomina')}
                            value={TipoNomina} onChange={handleTipoNomina}
                            >
                                <option key=""></option>
                                <option key="0" value="0">Indifferente</option>
                                <option key="1" value="1">Solo L. Rappresentante</option>
                                <option key="2" value="2">Solo Dipendente</option>
                            </Input>
                            {validator.current.message('TipoNomina', Nominale, 'required|numeric', { className: 'text-danger' })}
                    </FormGroup>
                </Col>
                ) 
                }
            </Row>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <Label for="selPermettiDownload">Permetti Download *</Label>
                        <Input type="select" name="selPermettiDownload" id="selPermettiDownload" placeholder=""
                            onBlur={() => validator.current.showMessageFor('PermettiDownload')}
                            value={PermettiDownload} onChange={handlePermettiDownload}
                            >
                                <option key=""></option>
                                <option key="0" value="0">No</option>
                                <option key="1" value="1">Si</option>
                            </Input>
                            {validator.current.message('PermettiDownload', PermettiDownload, 'required|numeric', { className: 'text-danger' })}
                    </FormGroup>
                </Col>
            </Row>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
            <div style={{width:"50%"}}>
                <Button  onClick={submitForm} className="btn-mbg btn-block">
                    Conferma {isSubmit ? ( <span className="spinner-border spinner-border-sm ml-5" role="status" aria-hidden="true"></span> ) : (<span></span>) }
                </Button>
            </div>
            <div style={{width:"50%"}}>
                    
                <Button onClick={props.handleClose} className="btn-block">
                    Annulla
                </Button>

            </div>            
        </DialogActions>
      </Dialog>
  );
}